import { render, staticRenderFns } from "./EventDetailItem2.vue?vue&type=template&id=22c7e1aa"
import script from "./EventDetailItem2.vue?vue&type=script&lang=ts"
export * from "./EventDetailItem2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports